import { API_BASE_URL, apiGet } from '@/api/http';

import type { Role } from '@/types/reference';

export const getRolesList = () =>
  apiGet<Role[]>(`${API_BASE_URL}candidate-roles/`);
